module.exports = __webpack_public_path__ + "static/media/be.2764c52c.svg";